import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, NgModule, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalOptions } from 'ngx-bootstrap/modal';
import { DateTime } from '../../../../../graphql';
import { appConfig } from '../../../../app.config';
import { ContactCardLegacy } from '../../../../data/repositories/contacts/contacts-legacy-convertor.service';
import { RepoContactsService } from '../../../../data/repositories/repo-contacts.service';

@Component({
    selector: 'app-contact-card-view',
    templateUrl: './contact-card-view.component.html',
    standalone: false,
})
export class ContactCardViewComponent implements OnInit {
    card!: Partial<ContactCardLegacy> & { isNew?: boolean };

    isNew?: boolean;
    cardTypes: any;
    dt?: DateTime | null;
    // @ts-ignore TS7008
    dateOptions;
    config: any;
    entityAspect: any;
    // @ts-ignore TS2564
    ID_Contact: string;
    // @ts-ignore TS2564
    locale: string;

    @Output() positiveAction = new EventEmitter();
    @Output() negativeAction = new EventEmitter();

    constructor(
        private contacts: RepoContactsService,
        private modalOptions: ModalOptions,
        private translateService: TranslateService
    ) {
        this.card = this.modalOptions.initialState as any;
    }

    ngOnInit() {
        this.isNew = this.card.isNew;
        this.cardTypes = this.contacts.CardTypes;
        this.dt = this.card.Expiry;
        this.config = appConfig().config;
        this.dateOptions = this.config.DATEPICKER;
        this.translateService.get('general.dateFormat').subscribe((res) => {
            this.locale = res;
        });
    }

    onChangeDate = () => {
        if (this.dt) this.card.Expiry = this.dt as Date;
    };

    ok() {
        this.positiveAction.emit();
    }

    cancel() {
        this.negativeAction.emit();
    }
}
@NgModule({
    imports: [CommonModule, FormsModule, BsDatepickerModule],
    declarations: [ContactCardViewComponent],
    exports: [ContactCardViewComponent],
})
export class ContactCardViewModule {}
